import { AlertType } from "./types";
import { initialAlert } from "../utils/constants";
import {
  GET_STORE_LOADING,
  GET_STORE_LOAD_MORE,
  GET_STORE_SUCESS,
  STORE_ALERT,
  GET_STORE_METADATA_LOADING,
  GET_STORE_METADATA_SUCESS,
  CLEAN_PROVIDER_METADATA,
  GET_STOREINTIGRATION_CONFIG_SUCESS,
  CLEAN_STORE_METADATA,
  GET_STOREINTIGRATION_CONFIG_ERROR,
  CREATE_STORE_LOADING,
  CREATE_STORE_FINISHED,
  STORE_MENU_SYNC_SUCCESS,
} from "../actions";
import { ConfigMetadataWrapper, StoreIntegration } from "../types/store";

interface StoreState {
  integrationList: StoreIntegration[];
  total: number;
  page: number;
  size: number;
  currentPage: number;
  hasMore: boolean;
  alert: AlertType;
  storeMetadata: ConfigMetadataWrapper;
  isLoading: boolean;
  error: string | null;
  storeIntegrationConfig: ConfigMetadataWrapper;
}

const initialState: StoreState = {
  integrationList: [],
  total: 0,
  page: 0,
  size: 20,
  currentPage: 0,
  hasMore: true,
  alert: initialAlert,
  storeMetadata: {
    configMetadata: {
      configType: "",
      providerName: "",
      sections: [],
    },
  },
  isLoading: false,
  error: null,
  storeIntegrationConfig: {
    configMetadata: {
      configType: "",
      providerName: "",
      sections: [],
    },
  },
};

export const storeReducer = (
  state = initialState,
  action: any
): StoreState => {
  switch (action.type) {
    case GET_STORE_LOADING:
    case GET_STORE_METADATA_LOADING:
    case CREATE_STORE_LOADING:
      return { ...state, isLoading: true, error: null, currentPage: 0, integrationList: [] };

    case GET_STORE_LOAD_MORE:
      return { ...state, error: null };

    case CREATE_STORE_FINISHED:
      return { ...state, isLoading: false, error: null };

    case GET_STORE_SUCESS:
      const isLoadMore = action.payload?.isLoadMore || false;
      const newPage = action.payload?.requestedPage || 0;
      const totalPages = Math.ceil((action.payload?.totalElements || 0) / (action.payload?.size || 20));
      
      return {
        ...state,
        integrationList: isLoadMore 
          ? [...state.integrationList, ...(action.payload?.storeIntegrationList || [])]
          : action.payload?.storeIntegrationList || [],
        total: action.payload?.totalElements || 0,
        page: action.payload?.page || 0,
        size: action.payload?.size || 20,
        currentPage: newPage,
        hasMore: newPage + 1 < totalPages,
        isLoading: false,
        error: null,
      };

    case GET_STORE_METADATA_SUCESS:
      return {
        ...state,
        storeMetadata: action.payload,
        isLoading: false,
        error: null,
      };

    case GET_STOREINTIGRATION_CONFIG_SUCESS:
    return {
      ...state,
      storeIntegrationConfig: action.payload,
      isLoading: false,
      error: null,
    };
    case GET_STOREINTIGRATION_CONFIG_ERROR:
    return {
      ...state,
      isLoading: false,
      error: action.payload,
    };

    case STORE_ALERT:
      return { ...state, alert: action.payload };

    case CLEAN_STORE_METADATA:
      return { ...state, storeMetadata: { configMetadata: { configType: "", providerName: "", sections: [] } } };

    case STORE_MENU_SYNC_SUCCESS:
      // Just handle the success notification
      return state;

    default:
      return state;
  }
};
